import { Link as MuiLink, Box, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { baseColors } from 'utils/constants';

const Footer = () => {
  const footerLinks: { label: string; href: string; internal?: boolean }[] = [
    {
      label: '個人情報保護方針',
      href: '/wp-content/themes/flatsome-child/assets/pdf/%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D.pdf'
    },
    { label: '利用規約', href: '/w/bridgewifi-term/' },
    { label: '特定商取引法の表記', href: '/w/bridgewifi-law/' },
    { label: 'お問合せ', href: '/w/bridgewifi-contact-us/' },
    { label: '会社概要', href: '/w/bridgewifi-company-profile/' }
  ];

  return (
    <Box sx={{ bgcolor: baseColors.bridgeBlue, color: baseColors.white, py: 4 }}>
      <Stack direction="row" justifyContent="center" flexWrap="wrap" spacing={3} sx={{ textAlign: 'center', maxWidth: '100%', mx: 'auto' }}>
        {footerLinks.map((link, i) =>
          link.internal ? (
            <MuiLink key={i} component={RouterLink} to={link.href} underline="none" color="inherit" sx={{ fontSize: { xs: 12, sm: 14 } }}>
              {link.label}
            </MuiLink>
          ) : (
            <MuiLink
              key={i}
              href={link.href}
              underline="none"
              color="inherit"
              target="_blank"
              rel="noopener"
              sx={{ fontSize: { xs: 12, sm: 14 } }}
            >
              {link.label}
            </MuiLink>
          )
        )}
      </Stack>

      <Typography variant="body2" align="center" sx={{ mt: 3, fontSize: { xs: 12, sm: 14 } }}>
        © 2015 - {new Date().getFullYear()}, WiFi Tokyo Renatal Shop.
      </Typography>
    </Box>
  );
};

export default Footer;
